import { render, staticRenderFns } from "./PreliminaryAmountAndTerm.vue?vue&type=template&id=27a787ee&scoped=true&"
import script from "./PreliminaryAmountAndTerm.vue?vue&type=script&lang=js&"
export * from "./PreliminaryAmountAndTerm.vue?vue&type=script&lang=js&"
import style0 from "./PreliminaryAmountAndTerm.vue?vue&type=style&index=0&id=27a787ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a787ee",
  null
  
)

export default component.exports